import React, { useContext, useEffect, useState } from "react";
import { Navbar , Nav , Container,Offcanvas,NavDropdown,Form, FormControl, Button,Image } from 'react-bootstrap';
import LoginModel from '../modals/login';
import AccountDetailsModel from "../modals/accountdetails";
import img from '../assets/logo.svg';

import { useLocation, useHistory } from "react-router-dom";
import { LoginContext } from "../../context/LoginContext";

//icons
import collection from '../assets/icons/archives-document.svg';
import bid from '../assets/icons/auction.svg';
import adoption from '../assets/icons/giftbox-gift.svg';
import market from '../assets/icons/market.svg';
import profile from '../assets/icons/profile-portfolio.svg';
import exchange from '../assets/icons/exchange-money.svg';
import account from '../assets/icons/old-style/person-circle.svg';
import help from '../assets/icons/help.svg';

const Menubar=()=>{
  const [showLoginModel,setShowLoginModel] = useState(false);
  const [showAccountDetailsModel,setShowAccountDetailsModel] = useState(false);
  const [loginData, setLoginData] =  useContext(LoginContext);
  const [expanded, setExpanded] = useState(false);
    
    const history = useHistory()

    return(
        <>
        <Navbar bg="light" expand={false}>
          <Container fluid>
            <Navbar.Brand href="/"><Image rounded="true" src={img}></Image>MSK-G</Navbar.Brand>
            <Nav></Nav><Nav></Nav><Nav></Nav><Nav></Nav><Nav></Nav><Nav></Nav><Nav></Nav><Nav></Nav><Nav></Nav>
            
            <Nav className="justify-content-end">
              {loginData?.walletAddress? 
                <Button variant="secondary" onClick={()=>setShowAccountDetailsModel(true)}>
                  <span><img style={{height:"2rem"}} src={account}/></span>
                  </Button>
                :
                <Button variant="secondary" onClick={()=>setShowLoginModel(true)}>Login</Button>
              }
            </Nav>
            <Navbar.Toggle aria-controls="navigationbar" onClick={() => setExpanded(expanded?false:true)}/>
            
            <Navbar.Offcanvas id="navigationbar" show={expanded} aria-labelledby="offcanvasNavbarLabel" placement="end" >
              <Offcanvas.Header closeButton onClick={()=>setExpanded(false)}>
                <Offcanvas.Title id="menubarTitle">Menu</Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Nav className="justify-content-end flex-grow-1 pe-3">
                  <Nav.Link onClick={()=>{history.push('/my-collection');setExpanded(false);}}><img style={{height:"2rem"}} src={collection}/> My Collection</Nav.Link>
                  <Nav.Link onClick={()=>{history.push('/my-bids');setExpanded(false);}}><img style={{height:"2rem"}} src={bid}/> My Bids</Nav.Link>
                  <Nav.Link onClick={()=>{history.push('/adoption');setExpanded(false);}}><img style={{height:"2rem"}} src={adoption}/> Adoption</Nav.Link>
                  <Nav.Link onClick={()=>{history.push('/market');setExpanded(false);}}><img style={{height:"2rem"}} src={market}/> Market</Nav.Link>
                  <Nav.Link onClick={()=>{history.push('/my-profile');setExpanded(false);}}><img style={{height:"2rem"}} src={profile}/> My Profile</Nav.Link>
                  <Nav.Link onClick={()=>{history.push('/exchange-token');setExpanded(false);}}><img style={{height:"2rem"}} src={exchange}/> Buy PANDAS Token</Nav.Link>
                  <Nav.Link onClick={()=>{history.push('/help');setExpanded(false);}}><img style={{height:"2rem"}} src={help}/> Help</Nav.Link>
                </Nav>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
        
        <>
          <LoginModel show={showLoginModel} onHide={() => setShowLoginModel(false)}/>
        </>
        <>
          <AccountDetailsModel show={showAccountDetailsModel} onHide={() => setShowAccountDetailsModel(false)}/>
        </>
      </>
    )
}
export default Menubar